import {DataSource} from '@angular/cdk/table';
import {IDynamic} from '../models/IDynamic';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {DynamicService} from '@shared/services/dynamic.service';
import {CollectionViewer} from '@angular/cdk/collections';
import {catchError, finalize} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {QueryParams} from '../../../models/queryParams';
import {config} from '../../../../app.config';

@Injectable()
export class DynamicDataSource implements DataSource<IDynamic> {
  public pageIndex = 0;
  private size = 0;
  private dataSubject = new BehaviorSubject<IDynamic[]>([]);
  private dataCountSubject = new BehaviorSubject<number>(0);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public count$ = this.dataCountSubject.asObservable();

  constructor(private dynamicService: DynamicService) {
  }

  connect(collectionViewer?: CollectionViewer): Observable<IDynamic[]> {
    return this.dataSubject.asObservable();
  }

  get count(): number {
    return this.dataCountSubject.value;
  }

  get pages(): number {
    // TODO - the problem is that 'size' is undefined
    return Math.ceil(this.dataCountSubject.value / (this.size || config.screenListItemsCount));
  }

  get data(): IDynamic[] {
    return this.dataSubject.value;
  }

  addItem(item: IDynamic): void {

    const current = this.dataSubject.value;

    this.dataSubject.next([item, ...current]);
    this.dataCountSubject.next(this.count + 1);
  }

  removeItem(index: number): void {
    const current = this.dataSubject.value;
    if (index < 0 || index >= current.length) {
      return;
    }
    const newArray = [
      ...current.slice(0, index),
      ...current.slice(index + 1)
    ];
    this.dataSubject.next(newArray);
    this.dataCountSubject.next(this.count - 1);
  }
  

  disconnect(collectionViewer: CollectionViewer): void {
    this.dataSubject.complete();
    this.dataCountSubject.complete();
    this.loadingSubject.complete();
  }

  /** Client-side rows for Settings lists that reuse dynamic-table without `/data`. */
  replaceData(rows: any[], pageIndex = 0, pageSize?: number): void {
    this.pageIndex = pageIndex;
    if (pageSize != null && pageSize > 0) {
      this.size = pageSize;
    }
    const list = (rows || []) as IDynamic[];
    this.dataCountSubject.next(list.length);
    this.dataSubject.next(list);
  }

  load(queryParams: QueryParams) {

    this.loadingSubject.next(true);
    this.size = +queryParams.pageSize;
    this.pageIndex = +queryParams.pageIndex || 0;
    this.dynamicService.find(
      queryParams.filter,
      queryParams.exactFilter,
      queryParams.ownerId,
      queryParams.searchParams,
      queryParams.searchRange,
      queryParams.searchRangeColumn,
      queryParams.archive,
      queryParams.sortBy,
      queryParams.direction,
      queryParams.pageIndex,
      queryParams.pageSize,
      queryParams.creditFilter,
      queryParams.pastClients,
    )
      .pipe(
        catchError(() => of([])),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(res => {
        this.dataCountSubject.next(res.count);
        return this.dataSubject.next(res.data);
      });
  }

  getReport(queryParams: QueryParams) {

    return this.dynamicService.find(
      queryParams.filter,
      false,
      queryParams.ownerId,
      queryParams.searchParams,
      queryParams.searchRange,
      queryParams.searchRangeColumn,
      queryParams.archive,
      queryParams.sortBy,
      queryParams.direction,
      queryParams.pageIndex,
      queryParams.pageSize,
      queryParams.creditFilter,
      queryParams.pastClients,
      true
    );
  }
}
